export default __webpack_public_path__ + "static/media/icon-cake.31d6cfe0.svg";